import React from "react";
import MainLayout from "../../components/Layout/MainLayout";
import { connect } from "react-redux";

import ol from "openlayers";
import { LocalStore } from "../../utils/LocalStore";

import { AxiosGetSecretApi } from "../../utils/fetchApi";
import { FetchGetSecretApi } from "../../utils/fetchApi";

import { Menu, Dropdown, message, Switch, Spin, Tooltip } from "antd";

import { toast } from 'react-toastify';

import "./TTQH.scss";

import Axios from 'axios';
// new so xay dung
import Search from "./MapPopup/Search";
import Note from "./MapPopup/Note";
import { showMapLayer } from "../../redux/actions/menu.action";
import SearchResult from "./MapPopup/SearchResult/index";

import SearchResultKienTruc from "./MapPopup/SearchResult/LopDuLieu/KienTruc";
import SearchResultQHCT from "./MapPopup/SearchResult/LopDuLieu/QuyHoachChiTiet";
import SearchResultQHPK from "./MapPopup/SearchResult/LopDuLieu/QuyHoachPhanKhu";
import SearchResultQHC from "./MapPopup/SearchResult/LopDuLieu/QuyHoachChung";
import {
  changeMapLayer,
  disableMapLayer,
} from "../../redux/actions/map.action";
import {
  changeBanDoGiay5000,
  changeBanDoGiay500,
  checkEnableMapLayer,
  getMyLocation,
  onDownloadMap,
  changeBanDoGiay10000,
} from "./Function/Map";
import ThongTinDuAn from "./MapPopup/ThongTinDuAn";
import Modal from "antd/lib/modal/Modal";
import {
  BanDo64,
  BienSoNha,
  Google_Layer_Ban_Do,
  Google_Layer_Ve_Tinh,
  iconStyle,
  KienTruc,
  QHCT_Line,
  QHCT_Polygon,
  QHCT_RanhGioi,
  QHC_Line,
  QHC_Polygon,
  QHPK_Line,
  QHPK_Polygon,
  QHPK_RanhGioi,
  RanhGioiDiaChinh,
  ThongTinDiaChinh,
  RanhGioiHanhChinh,
  QHC_HienTrang,
  QHC_Test,
  QHC_RanhGioi,
} from "../../components/ListLayer";
import SearchQHCT from './MapPopup/SearchLayer/SearchQHCT';
import SearchQHPK from './MapPopup/SearchLayer/SearchQHPK';
import {
  formatArea,
  formatLength,
  removeVecterDraw,
  createMeasureTooltip,
  createHelpTooltip,
} from "./Function/draw";
import SearchQHC from "./MapPopup/SearchLayer/SearchQHC";
import SearchResultNamQHC from './MapPopup/SearchResult/LopDuLieu/SearchResultNamQHC';
import SearchKienTruc from './MapPopup/SearchLayer/SearchKienTruc';

//trasform toa do
import proj4 from "proj4";
import StaticClass from "../../utils/staticClass";
proj4.defs(
  "EPSG:6959",
  "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs"
);

class HomaPage extends React.Component {
  constructor(props) {
    super(props);
    // ban do giay
    this._imgLayer = null;
    this._imgOvelayerLink = "";
    this._urlImageOverlay = "";

    this._vectorLayer = null;
    this._coordinateOverlay = null;

    this.vectorSource1 = null;

    //count layer added

    this._markerAround = null;

    this.state = {
      _isDigitalMap: true,
      _isShowFullImg: null,
      _isShowImgOverlay: false,

      showProgressBar: false,
      isLoading: false,
      _isVisibleTabSearch: 1,

      // thao tac ban bo
      typeSelect: "none",

      // popup lop ban do
      CheckedLayerKeys: ["RanhGioiDiaChinh", "BienSoNha"],
      isEnableLayerPopup: false,

      // popup
      isShowSearchPopup: false,
      isShowNotePopup: false,
      isShowResultPopup: false,

      // data search
      dataThuaDat: null,
      dataQuyHoach: null,
      dataQuyHoachPhanKhu: null,
      dataKienTruc: null,

      // data lop ban do
      isShowSearchKienTruc: false,
      dataSearchResultKienTruc: false,

      isShowSearchQHCT: false,
      dataSearchResultQHCT: false,

      isShowSearchQHC: false,
      dataSearchResultQHC: false,

      isShowSearchNamQHC: false,
      dataSearchResultNamQHC: false,

      isShowSearchQHPK: false,
      dataSearchResultQHPK: false,

      // nen ban do
      checkedVeTinh: false,
      checkedBanDo: true,
      checkedBanDoGiay: false,
    };

    //-----tool-ve-----//
    this.wgs84Sphere = new ol.Sphere(6378137);
    this.source = new ol.source.Vector();
    this.draw = null;
    this.sketch = null;
    this.continuePolygonMsg = "Click để tiếp tục vẽ hình đa giác";
    this.continueLineMsg = "Click để tiếp tục vẽ đường";
    this.helpTooltipElement = undefined;
    this.measureTooltipElement = undefined;
    this.measureTooltip = undefined;
    this.helpTooltip = undefined;
    this.buttonClick = undefined;
    this._vectorLayer_MB = null;
    this._iconGeometry = new ol.geom.Point([
      12045324.924720876,
      1806357.9277613866,
    ]);
    //-----=====-----//

    //-----map-----//
    this.map = {};

    // layer
    this.arrLayer = [];
    this.BaseLayer = {
      // google
      Google_Layer_Ve_Tinh: Google_Layer_Ve_Tinh,
      Google_Layer_Ban_Do: Google_Layer_Ban_Do,

      // lop nen
      RanhGioiDiaChinh: RanhGioiDiaChinh,
      ThongTinDiaChinh: ThongTinDiaChinh,
      RanhGioiHanhChinh: RanhGioiHanhChinh,
      BanDo64: BanDo64,
      BienSoNha: BienSoNha,

      // private
      QHCT_Polygon: QHCT_Polygon,
      QHCT_Line: QHCT_Line,
      QHCT_RanhGioi: QHCT_RanhGioi,

      QHPK_Polygon: QHPK_Polygon,
      QHPK_Line: QHPK_Line,
      QHPK_RanhGioi: QHPK_RanhGioi,

      QHC_Polygon: QHC_Polygon,
      QHC_Line: QHC_Line,
      QHC_HienTrang: QHC_HienTrang,
      QHC_Test: QHC_Test,
      QHC_RanhGioiQuyHoach: QHC_RanhGioi,
      KienTruc: KienTruc,
    };

    this.OBJECTID = null;

    this.listPrivateLayer = [
      "QHCT_Polygon",
      "QHCT_Line",
      "QHCT_RanhGioi",
      "QHPK_Polygon",
      "QHPK_Line",
      "QHPK_RanhGioi",
      "QHC_Polygon",
      "QHC_HienTrang",
      "QHC_Test",
      "QHC_Line",
      "KienTruc",
      "QHC_RanhGioiQuyHoach"
    ];
  }

  componentDidMount() {
    this.getBanDoGiay10000();
    this.props.changeMapLayer(["RanhGioiDiaChinh", "BienSoNha"]);
    // if (this.isLogged()) {
      this.props.showMapLayer(true);
    // }
    
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.isShowMenu !== this.props.isShowMenu) {
      if (this.map) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }

    if (prevProps.isShowMapLayer !== this.props.isShowMapLayer) {
      if (this.map && this.map.updateSize) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }

    if (prevProps.isEnableLayer !== this.props.isEnableLayer) {
      if (this._vectorLayer_MB) {
        this._vectorLayer_MB.setSource(undefined);
        this._overlayPopup.setPosition(undefined);
      }
      if (this._vectorLayer) {
        this._vectorLayer.getSource().clear();
      }
      checkEnableMapLayer(this);
      // this.setState({checkedBanDoGiay:false})
      if(prevProps.isEnableLayer?.includes('QHCT_Polygon') && prevState.checkedBanDoGiay) {
        changeBanDoGiay500(false, this, true)
      }
      if(prevProps.isEnableLayer?.includes('QHPK_Polygon') && prevState.checkedBanDoGiay ) {
        changeBanDoGiay5000(false, this, true)
      }
      if(prevProps.isEnableLayer?.includes('QHC_Polygon') && prevState.checkedBanDoGiay  ) {
        changeBanDoGiay10000(false, this, true)
      }
      this.setState({
        isShowSearchQHCT: false,
        isShowSearchQHC: false,
        isShowSearchNamQHC: false,
        isShowSearchQHPK: false,
        isShowResultPopup: false,
        isShowSearchPopup:false,
        isShowSearchKienTruc: false,
      })
      
    }    
    
    if (prevProps.isEnableLayer !== this.props.isEnableLayer && 
      this.props.isEnableLayer[0] !== 'RanhGioiDiaChinh' && 
      this.props.isEnableLayer[1] !== 'BienSoNha'
      ) {
      console.log(this.props.isEnableLayer, 'this.props.isEnableLayer' );
      this.setState({isShowSearchPopup: true})
    }

    if (prevState.checkedBanDoGiay !== this.state.checkedBanDoGiay) {
      this.setState({
        isShowInfoPopup: false,
      });
      if (this._imgLayer) {
        this._imgLayer.setSource(undefined);
      }
    }

    if (
      prevState.isShowResultPopup !== this.state.isShowResultPopup &&
      !this.state.isShowResultPopup
    ) {
      this.hideMakerPointAround();
    } 

    if (
      prevProps.isResetLayer !== this.props.isResetLayer
    ) {
      this.onResetMap();
    }

    if (
      prevState.isShowSearchKienTruc !== this.state.isShowSearchKienTruc &&
      !this.state.isShowSearchKienTruc
    ) {
      this.hideMakerPointAround();
    }

    if (
      prevState.isShowSearchQHCT !== this.state.isShowSearchQHCT &&
      !this.state.isShowSearchQHCT
    ) {
      this.hideMakerPointAround();
    }

    if (
      prevState.isShowSearchQHPK !== this.state.isShowSearchQHPK &&
      !this.state.isShowSearchQHPK
    ) {
      this.hideMakerPointAround();
    }
  }

  componentWillUnmount() {
    if (this.timeOutID) {
      clearTimeout(this.timeOutID);
    }
  }

  isLogged = () => {
    let token = LocalStore.getInstance().read("loginSession");
    if (token) {
      return true;
    }
    return false;
  };

  async getImageBanDoGiay(url) {
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      let extent = [res[0].Left, res[0].Bottom, res[0].Right, res[0].Top];
      extent = ol.proj.transformExtent(
        extent,
        ol.proj.get("EPSG:4326"),
        ol.proj.get("EPSG:3857")
      );

      this.map.getView().setCenter(ol.extent.getCenter(extent));
      this.map.getView().fit(extent, this.map.getSize(), { duration: 2000 });




      this._imgOvelayerLink = res[0].URL + "/" + res[0].Name;
      if (this._imgLayer) {
        this._imgLayer.setSource(
          new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,
          })
        );
      } else {
        this._imgLayer = new ol.layer.Image({
          source: new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,

          }),
        });
        this.map.getLayers().push(this._imgLayer);
      }
      return;
    }
    message.error("Không có thông tin bản đồ (dữ liệu đang cập nhật)");
  }

  async getFullImangeBanDoGiay(url) {
    
    let res = await AxiosGetSecretApi(url + "a");

    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      this.setState({srcImgFull: res[0].URL + "/" + res[0].Name})
    } else {
      this.setState({srcImgFull: ''})
    }
  }

  async getDuAnBanDoGiay(url) {
    this.setState({
      isShowSearchPopup: false,
      isShowResultPopup: false,
      isShowSearchKienTruc: false,
      isShowSearchQHC: false,
      isShowSearchNamQHC: false,
      isShowSearchQHCT: false,
      isShowSearchQHPK: false,
    });
    let res = await FetchGetSecretApi(url);
    if (
      res &&
      res.features &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length > 0
    ) {
      this.setState({
        isShowInfoPopup: true,
        thongTinDuAn: res.features[0].properties,
      });
      let poly = res.features[0];

      if (this.state.BDGiay_500) {
        if (
          poly.properties &&
          poly.properties.Madoan &&
          poly.properties.Madoan !== "null" &&
          poly.properties.Madoan !== "Null"
        ) {
          let urlImg = `/api/ban-do-giay/tim-theo-ma?code=${poly.properties.Madoan}`;

          this.getImageBanDoGiay(urlImg, poly);
          this.getFullImangeBanDoGiay(urlImg);
          return;
        }
      }

      if (this.state.BDGiay_5000) {
        if (
          poly.properties &&
          poly.properties.MaPhanKhu &&
          poly.properties.MaPhanKhu !== "null" &&
          poly.properties.MaPhanKhu !== "Null"
        ) {
          let urlImg = `/api/ban-do-giay/tim-theo-ma-pk?code=${poly.properties.MaPhanKhu}`;
          // this.imgFullMap = `/api/ban-do-giay/tim-theo-ma-pk?code=${poly.properties.MaPhanKhu}a`;
          this.getImageBanDoGiay(urlImg, poly);
          this.getFullImangeBanDoGiay(urlImg);
          return;
        }
      }
      return;
    }
    this.setState({
      isShowInfoPopup: false,
      thongTinDuAn: undefined,
    });
    message.error("Không có thông tin (dữ liệu đang cập nhật)");
  }

  // --------------------map-------------------- //

  // init map

  async getBanDoGiay10000() {
    let res = await AxiosGetSecretApi(
      "/api/ban-do-giay/tim-theo-ma-chung?code=1"
    );
    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      this.setState({
        isShowButtonMap: true,
      });
      let extent = [res[0].Left, res[0].Bottom, res[0].Right, res[0].Top];
      extent = ol.proj.transformExtent(
        extent,
        ol.proj.get("EPSG:4326"),
        ol.proj.get("EPSG:3857")
      );

      // this._imgOvelayerLink = res[0].URL + "/" + res[0].Name;
      this.BaseLayer.QHC_RanhGioi = new ol.layer.Image({
        source: new ol.source.ImageStatic({
          url: res[0].URL + "/" + res[0].Name,
          imageExtent: extent,
        }),
      });
    }

    let res10000 = await AxiosGetSecretApi(
      "/api/ban-do-giay/tim-theo-ma-chung?code=1a"
    );
    if (
      res10000 &&
      Array.isArray(res10000) &&
      res10000.length > 0 &&
      res10000[0].URL
    ) {
      this.setState({
        isShowButtonMap: true,
      });

      this.srcImgFull10000 = res10000[0].URL + "/" + res10000[0].Name;
    }

    this.initMap();
  }
  initMap() {
    let tile_loading = 0,
      tile_loaded = 0;
    let checkLoaded = false;
    this.BaseLayer.RanhGioiDiaChinh.on("tileloadstart", function (event) {
      ++tile_loading;
      // do some stuff start loading tiles...
      // console.log('start', tile_loading);
    });

    this.BaseLayer.RanhGioiDiaChinh.on("tileloadend", function (event) {
      ++tile_loaded;
      // console.log('end', tile_loaded);

      if (tile_loaded === tile_loading) {
        checkLoaded = true;
      }
    });

    this.timeOutID = setTimeout(() => {
      if (!checkLoaded) {
        message.error(
          "Bạn cần nâng cấp chất lượng 3G/4G hoặc chất lượng đường truyền để đạt hiệu suất tối ưu nhất"
        );
      }
    }, 5000);

    // this.map.getLayers().push(this.BaseLayer.QHC_RanhGioi);

    // --------------------draw icon-------------------- //
    let iconFeature = new ol.Feature({
      geometry: this._iconGeometry,
      name: "Null Island",
      population: 4000,
      rainfall: 500,
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new ol.source.Vector({
      features: [iconFeature],
    });

    let vectorLayer = new ol.layer.Vector({
      source: vectorSource,
    });
    vectorLayer.setZIndex(99);
    // --------------------=====-------------------- //

    this.arrLayer.push(this.BaseLayer.Google_Layer_Ban_Do);
    this.arrLayer.push(this.BaseLayer.Google_Layer_Ve_Tinh);

    this.listPrivateLayer.forEach((e) => {
      if (this.BaseLayer[`${e}`]) {
        this.BaseLayer[`${e}`].setVisible(false);
        this.arrLayer.push(this.BaseLayer[`${e}`]);
      }
    });

    // for (let i = 0; i < this.listPrivateLayer.length; i++) {
    //   if (
    //     this.BaseLayer[
    //       `${this.listPrivateLayer[this.listPrivateLayer.length - i - 1]}`
    //     ]
    //   ) {
    //     this.BaseLayer[
    //       `${this.listPrivateLayer[this.listPrivateLayer.length - i - 1]}`
    //     ].setVisible(false);
    //     this.arrLayer.push(
    //       this.BaseLayer[
    //         `${this.listPrivateLayer[this.listPrivateLayer.length - i - 1]}`
    //       ]
    //     );
    //   }
    // }

    if (this.BaseLayer.QHC_RanhGioi) this.arrLayer.push(this.BaseLayer.QHC_RanhGioi);

    this.arrLayer.push(this.BaseLayer.RanhGioiDiaChinh);
    this.arrLayer.push(this.BaseLayer.ThongTinDiaChinh);
    this.arrLayer.push(this.BaseLayer.RanhGioiHanhChinh);

    this.arrLayer.push(this.BaseLayer.BienSoNha);

    this.arrLayer.push(this.BaseLayer.BanDo64);
    // this.arrLayer.push(vectorLayer);

    this.BaseLayer.Google_Layer_Ban_Do.setVisible(true);
    this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(false);
    this.BaseLayer.RanhGioiDiaChinh.setVisible(true);
    this.BaseLayer.ThongTinDiaChinh.setVisible(false);
    this.BaseLayer.RanhGioiHanhChinh.setVisible(false);
    this.BaseLayer.BienSoNha.setVisible(true);
    if (this.BaseLayer.QHC_RanhGioi) this.BaseLayer.QHC_RanhGioi.setVisible(false);

    ///bat dau ve -------------------------------------------------------------------------------------------------------------
    let vector = new ol.layer.Vector({
      source: this.source,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new ol.style.Stroke({
          color: "#00FFFF",
          width: 2,
        }),
        image: new ol.style.Circle({
          radius: 7,
          fill: new ol.style.Fill({
            color: "#ffcc33",
          }),
        }),
      }),
    });

    let container = document.getElementById("popup");
    let closer = document.getElementById("popup-closer");

    this._overlayPopup = new ol.Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    let seft = this;
    closer.onclick = function () {
      seft._overlayPopup.setPosition(undefined);
      closer.blur();
      return false;
    };

    this.map = new ol.Map({
      layers: [...this.arrLayer, vector],
      loadTilesWhileInteracting: true,
      target: "map",
      view: new ol.View({
        code: "EPSG:10775",
        center: [12045324.924720876, 1806357.9277613866],
        zoom: 14,
        minZoom: 6,
        maxZoom: 21,
      }),
      overlays: [this._overlayPopup],
      controls: ol.control.defaults({
        attribution: false,
        zoom: true,
      }),
    });

    this.addInteraction.call(this);
  }

  // draw
  drawLine = (SHAPE) => {
    let feature;

    let dataPoints = SHAPE.points.map((e) => {
      let arrLocation = [e.x, e.y];
      arrLocation = proj4("EPSG:6959").inverse(arrLocation);
      arrLocation = ol.proj.transform(arrLocation, "EPSG:4326", "EPSG:3857");

      return arrLocation;
    });
    feature = new ol.Feature({
      geometry: new ol.geom.LineString(dataPoints),
    });

    let vectorSource = new ol.source.Vector({
      features: [feature],
    });

    let aa = feature.getGeometry().getExtent();
    let oo = ol.extent.getCenter(aa);
    // this._iconGeometry.setCoordinates(oo);
    this.map.getView().setCenter(oo);

    this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

    if (this.map.getView().getZoom() > 21) {
      this.map.getView().setZoom(21);
    }

    if (this._vectorLayer) {
      this._vectorLayer.setSource(
        new ol.source.Vector({
          features: [feature],
        })
      );
    } else {
      this._vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        style: new ol.style.Style({
          stroke: new ol.style.Stroke({ color: "#00FFFF", width: 2 }),
          fill: new ol.style.Fill({ color: "#1F86EB" }),
        }),
      });
      this.map.getLayers().push(this._vectorLayer);
    }
  };

  drawPolygonSearch = (data) => {
    data = data.map((a) => [...a].reverse()); //reverse data
    // debugger
    let newDataConvert = [];
    for (let e of data) {
      let arrToNumber = e.map(Number);
      let arrTO86 = proj4("EPSG:6959").inverse(arrToNumber);
      let result = ol.proj.transform(arrTO86, "EPSG:4326", "EPSG:3857");
      newDataConvert.push(result);
    }
    let caculateG = () => {
      let x = 0;
      let y = 0;
      for (let i = 0; i < newDataConvert.length; i++) {
        x += parseFloat(newDataConvert[i][0]);
        y += parseFloat(newDataConvert[i][1]);
      }
      let G = [x / newDataConvert.length, y / newDataConvert.length];
      // debugger;
      if (newDataConvert.length >= 3) {
        newDataConvert.push(newDataConvert[0]);
        this.map.getLayers().pop();
      }
      // newDataConvert = newDataConvert.map(Number)
      var polygon = new ol.geom.Polygon([newDataConvert]);

      var feature = new ol.Feature(polygon);

      // Create vector source and the feature to it.
      this.vectorSource1 = new ol.source.Vector();
      this.vectorSource1.addFeature(feature);

      // Create vector layer attached to the vector source.
      var vectorLayer1 = new ol.layer.Vector({
        source: this.vectorSource1,
        style: new ol.style.Style({
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
          stroke: new ol.style.Stroke({
            color: "#00FFFF",
            width: 2,
          }),
          image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
              color: "#00FFFF",
            }),
          }),
        }),
      });

      // Add the vector layer to the map.
      this.map.addLayer(vectorLayer1);
      this.setLocation(G, 18);
    };
    // let tranf = ol.proj.transform([parseFloat(oo.x), parseFloat(oo.y)], 'EPSG:4326', 'EPSG:3857');
    if (newDataConvert.length === 1) {
      this.setLocation(newDataConvert[0], 18);
    } else if (newDataConvert.length === 2) {
      caculateG();
    } else if (newDataConvert.length >= 3) {
      caculateG();
    }
  };

  // vi tri
  setLocation = (oo, zoom) => {
    this.map.getView().setCenter(oo);
    if (zoom) {
      this.map.getView().setZoom(zoom);
    }
    this._iconGeometry.setCoordinates(oo);
  };

  // Thao tac ban do

  onChangeTypeTool = (value) => {
    if (this.state.typeSelect !== value) {
      this.setState(
        {
          typeSelect: value,
        },
        this.addInteraction.bind(this)
      );
      this.map.removeInteraction(this.draw);
    }
  };

  async addInteraction() {
    if (this.state.typeSelect === "point") {
      if (this.measureTooltipElement && this.measureTooltipElement !== null)
        this.measureTooltipElement.innerHTML = "";
      if (this.helpTooltipElement && this.helpTooltipElement !== null)
        this.helpTooltipElement.innerHTML = "";

      this.map.removeEventListener("singleclick");
      let element1 = document.querySelector(".tooltip-1.hidden");
      if (element1) {
        element1.style.display = "none";
      }
      this.Point = new ol.interaction.Draw({
        source: this.source,
        type: "Point",
      });
      this.Point.getActive();

      this.Point.setActive(true);
      this.Snap = new ol.interaction.Snap({
        source: this.source,
      });
      this.map.addInteraction(this.Point);
      this.map.addInteraction(this.Snap);
    } else if (this.state.typeSelect !== "none") {
      createMeasureTooltip(this);
      createHelpTooltip(this);
      //remove singleclick
      this.map.removeEventListener("singleclick");
      this.Point && this.Point.setActive(false);
      //ve help click .......
      this.map.on("pointermove", (evt) => {
        if (evt.dragging) {
          return;
        }
        /* @type {string} */
        let helpMsg = "Click để bắt đầu vẽ";
        if (this.sketch) {
          let geom = this.sketch.getGeometry();
          if (geom instanceof ol.geom.Polygon) {
            helpMsg = this.continuePolygonMsg;
          } else if (geom instanceof ol.geom.LineString) {
            helpMsg = this.continueLineMsg;
          }
        }

        if (
          this.buttonClick !== "KhoangCach" &&
          this.buttonClick !== "DienTich"
        ) {
          helpMsg = "";
        }

        this.helpTooltipElement.innerHTML = helpMsg;
        this.helpTooltip.setPosition(evt.coordinate);
        this.helpTooltipElement.classList.remove("hidden");
      });
      this.map.getViewport().addEventListener("mouseout", () => {
        this.helpTooltipElement.classList += " hidden";
      });

      // logic ve--------------------------------------
      let type = this.state.typeSelect === "area" ? "Polygon" : "LineString";
      this.draw = new ol.interaction.Draw({
        source: this.source,
        type: /* @type {ol.geom.GeometryType} */ type,
        style: new ol.style.Style({
          fill: new ol.style.Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
          stroke: new ol.style.Stroke({
            color: "#00FFFF",
            lineDash: [10, 10],
            width: 2,
          }),
          image: new ol.style.Circle({
            radius: 5,
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
            }),
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
          }),
        }),
      });
      this.map.addInteraction(this.draw);
      this.Snap && this.map.addInteraction(this.Snap);

      let listener;

      this.draw.on("drawstart", (evt) => {
        // set sketch
        this.sketch = evt.feature;

        let tooltipCoord = evt.coordinate;

        listener = this.sketch.getGeometry().on("change", (evt) => {
          let geom = evt.target;
          let output;
          if (geom instanceof ol.geom.Polygon) {
            output = formatArea(geom, this);
            tooltipCoord = geom.getInteriorPoint().getCoordinates();
          } else if (geom instanceof ol.geom.LineString) {
            // output = this.formatLength(geom);
            output = formatLength(geom, this);
            tooltipCoord = geom.getLastCoordinate();
          }
          this.measureTooltipElement.innerHTML = output;
          this.measureTooltip.setPosition(tooltipCoord);
        });
      });

      this.draw.on("drawend", (evt) => {
        removeVecterDraw(this);
        this.measureTooltipElement.className = `tooltip tooltip-static delete`;

        this.measureTooltip.setOffset([0, -7]);
        // unset sketch
        this.sketch = null;
        // unset tooltip so that a new one can be created
        this.measureTooltipElement = null;
        createMeasureTooltip(this);
        ol.Observable.unByKey(listener);
      });
    } else {
      // logic click search
      let element1 = document.querySelector(".tooltip.hidden");
      if (element1) {
        element1.style.display = "none";
      }
      this.map.on("singleclick", async (evt) => {
        // this.setLocation(evt.coordinate);
        let view = this.map.getView();
        let viewResolution = view.getResolution();

        //  co ban do giay
        if (this.state.checkedBanDoGiay) {
          let source = undefined;

          // ban do 1/500
          if (this.state.BDGiay_500) {
            source = this.BaseLayer.QHCT_RanhGioi.getSource();
          }

          // ban do 1/5000
          if (this.state.BDGiay_5000) {
            source = this.BaseLayer.QHPK_RanhGioi.getSource();
          }

          // ban do 1/10000
          if (this.state.BDGiay_10000) {
            // message.error("Chưa có thông tin (Dữ liệu đang cập nhật)");
            this.setState({ isShowInfoPopup: true });
            return;
          }

          if (source) {
            let url = source.getGetFeatureInfoUrl(
              evt.coordinate,
              viewResolution,
              view.getProjection(),
              {
                INFO_FORMAT: "application/geojson",
                FEATURE_COUNT: "50",
              }
            );
            this.getDuAnBanDoGiay(url);
          }
          return;
        }

        // ko co ban do giay
        let listLayer = this.props.isEnableLayer;

        // co lop du liẹu
        let selectedLopDuLieu = undefined;

        // click searchLoaiDat
        let sourceLoaiDat = undefined;

        for (let i = 0; i < this.listPrivateLayer.length; i++) {
          if (listLayer.includes(this.listPrivateLayer[i])) {
            selectedLopDuLieu = this.listPrivateLayer[i];
            break;
          }
        }
        // remove click QHC_RanhGioiQuyHoach
        if(selectedLopDuLieu === 'QHC_RanhGioiQuyHoach'){
          return
        }

        if (selectedLopDuLieu) {
          if (!this.BaseLayer[`${selectedLopDuLieu}`]) {
            message.error("Chưa có thông tin (Dữ liệu đang cập nhật)");
            return;
          }
          let source = this.BaseLayer[`${selectedLopDuLieu}`].getSource();
          let url = source.getGetFeatureInfoUrl(
            evt.coordinate,
            viewResolution,
            view.getProjection(),
            {
              INFO_FORMAT: "application/geojson",
              FEATURE_COUNT: "50",
            }
          );

          let urlHienTrang = undefined;
          if (
            selectedLopDuLieu === "QHC_Polygon" &&
            listLayer.includes("QHC_HienTrang")
          ) {
            let sourceQHC = this.BaseLayer.QHC_HienTrang.getSource();
            urlHienTrang = sourceQHC.getGetFeatureInfoUrl(
              evt.coordinate,
              viewResolution,
              view.getProjection(),
              {
                INFO_FORMAT: "application/geojson",
                FEATURE_COUNT: "50",
              }
            );
          }

          let resLopDuLieu = await FetchGetSecretApi(url);
          if (
            resLopDuLieu &&
            resLopDuLieu.features &&
            Array.isArray(resLopDuLieu.features) &&
            resLopDuLieu.features.length !== 0
          ) {
            if (selectedLopDuLieu.includes("QHCT_")) {
              if(this.state.dataSearchResultQHCT?.MaDuAn !== resLopDuLieu.features[0].properties?.MaDuAn){
                this.setState({dataSearchResultQHCT: resLopDuLieu.features[0].properties,})
              }              
              if(this.state.dataSearchResultQHCT?.Madoan !== resLopDuLieu.features[0].properties?.Madoan){
                this.setState({dataSearchResultQHCT: resLopDuLieu.features[0].properties,})
              }
              this.setState({
                isShowSearchQHCT: true,
                isShowSearchQHPK: false,
                isShowSearchKienTruc: false,
                isShowSearchQHC: false,
                isShowSearchNamQHC: false,
              });
              if(selectedLopDuLieu.includes('QHCT_Polygon')){
                if (!this.state.checkedBanDoGiay) {
                  sourceLoaiDat = this.BaseLayer.QHCT_Polygon.getSource();
                }
              }
            }

            if (selectedLopDuLieu.includes("QHPK_")) {
              if(this.state.dataSearchResultQHPK?.MaPhanKhu !== resLopDuLieu.features[0].properties?.MaPhanKhu){
                this.setState({dataSearchResultQHPK: resLopDuLieu.features[0].properties,})
              }
              this.setState({
                isShowSearchQHCT: false,
                isShowSearchQHPK: true,
                isShowSearchKienTruc: false,
                isShowSearchQHC: false,
                isShowSearchNamQHC: false,
              });
              if(selectedLopDuLieu.includes('QHPK_Polygon')){
                if (!this.state.checkedBanDoGiay) {
                  sourceLoaiDat = this.BaseLayer.QHPK_Polygon.getSource();
                }
              }
            }

            if (selectedLopDuLieu.includes("QHC_")) {
              this.setState({
                isShowSearchQHCT: false,
                isShowSearchQHPK: false,
                isShowSearchKienTruc: false,
                isShowSearchQHC: true,
                isShowSearchNamQHC: false,
                dataSearchResultQHC: resLopDuLieu.features[0].properties,
              });
            }

            if (selectedLopDuLieu.includes("KienTruc")) {
              this.setState({
                isShowSearchQHCT: false,
                isShowSearchQHPK: false,
                isShowSearchKienTruc: true,
                isShowSearchQHC: false,
                isShowSearchNamQHC: false,
                dataSearchResultKienTruc: resLopDuLieu.features[0].properties,
              });
            }

            this.OBJECTID = resLopDuLieu.features[0].properties;

            this.setState({
              isShowInfoPopup: false,
              isShowSearchPopup: false,
              isShowResultPopup: false,
            });

            if (sourceLoaiDat && !this.state.checkedBanDoGiay) { // draw loai dat
              let url = sourceLoaiDat.getGetFeatureInfoUrl(
                evt.coordinate,
                viewResolution,
                view.getProjection(),
                {
                  INFO_FORMAT: "application/geojson",
                  FEATURE_COUNT: "50",
                }
              );
              this.getLoaiDat(url);
              this._coordinateOverlay = evt.coordinate;
            }
            return;
          } else {
            if (
              selectedLopDuLieu === "QHC_Polygon" &&
              listLayer.includes("QHC_HienTrang")
            ) {
              let resLopDuLieuQHC = await AxiosGetSecretApi(urlHienTrang);

              if (
                resLopDuLieuQHC &&
                resLopDuLieuQHC.features &&
                Array.isArray(resLopDuLieuQHC.features) &&
                resLopDuLieuQHC.features.length !== 0
              ) {
                this.setState({
                  isShowSearchQHCT: false,
                  isShowSearchQHPK: false,
                  isShowSearchKienTruc: false,
                  isShowSearchQHC: true,
                  isShowSearchNamQHC: false,
                  dataSearchResultQHC: resLopDuLieuQHC.features[0].properties,
                });

                this.setState({
                  isShowInfoPopup: false,
                  isShowSearchPopup: false,
                  isShowResultPopup: false,
                });

                return;
              }
            }
            this.setState({
              isShowInfoPopup: false,
              isShowSearchPopup: false,
              isShowResultPopup: false,
              isShowSearchKienTruc: false,
              isShowSearchQHPK: false,
              isShowSearchQHCT: false,
              isShowSearchQHC: false,
              isShowSearchNamQHC: false,
            });
            message.error("Không có dữ liệu (Thông tin đang cập nhật)");
            return;
          }
        }

        // khong co lop du lieu
        if (this.state.CheckedLayerKeys.includes("RanhGioiDiaChinh")) {
          let source = this.BaseLayer.RanhGioiDiaChinh.getSource();
          let url = source.getGetFeatureInfoUrl(
            evt.coordinate,
            viewResolution,
            view.getProjection(),
            {
              INFO_FORMAT: "application/geojson",
              FEATURE_COUNT: "50",
            }
          );
          
          let resLopNen = await FetchGetSecretApi(url);
          if (
            resLopNen &&
            resLopNen.features &&
            Array.isArray(resLopNen.features) &&
            resLopNen.features.length !== 0 &&
            resLopNen.features[0].properties
          ) {
            let x = resLopNen.features[0].properties;
            let data = {
              selectedPhuong: x.IDPhuong,
              SoTo: x.SoToBD,
              SoThua: x.SoThua,
            };
            if (resLopNen.features[0].properties.LoaiDat.trim() !== "DGT") {
              this.searchBySoTo(data);
            } else {
              message.error("Chưa có thông tin (Dữ liệu đang cập nhật)");
            }
          } else {
            message.error("Chưa có thông tin (Dữ liệu đang cập nhật)");
          }
        }
      });
    }
  }

  // get data loai dat

  async getLoaiDat(url) {
    let res = await FetchGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties
    ) {
      this.showOverLayeInfo(res.features[0].properties);
    }
  }
  async showOverLayeInfo(data) {
    let _contentPopup = document.getElementById("popup-content");
    if (this.props.isEnableLayer.includes("QHCT_Polygon")) {
      let dataDuAn = undefined
      if (this.props.isEnableLayer.includes("QHCT_Polygon") 
      // && this.props.listDuAn
      ) {
        if (data && data.OBJECTID) {
          let res = await AxiosGetSecretApi(
            `/api/duanqh/getById-mb?ID=${data.OBJECTID}`
          );
          if (res && res.length !== 0) {
            dataDuAn = res[0];
              this.drawPolygon(res[0], null, 'true');
          }
        }
      }
      _contentPopup.innerHTML =
        '<div class="header-title-popup">Thông tin chi tiết mặt bằng quy hoạch</div>' +
        "</hr>" +
        `<div style="display: flex;">
            <div class="text-title-popup">Tên dự án:</div>
            <div class="text-content-popup">${dataDuAn?.Tendoan || "-"}</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Tên loại đất:</div>
            <div class="text-content-popup">${
              dataDuAn.TenloaiPolygon ? dataDuAn.TenloaiPolygon : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Diện tích (m²):</div>
            <div class="text-content-popup">${
              dataDuAn && dataDuAn.DienTichFormat
              ? StaticClass.formatPrice(dataDuAn.DienTichFormat)
              : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Mô tả:</div>
            <div class="text-content-popup">${dataDuAn.MoTa ? dataDuAn.MoTa : "-"}</div>
        </div> `;
      this._overlayPopup.setPosition(this._coordinateOverlay);
      return;
    }

    if (this.props.isEnableLayer.includes("QHPK_Polygon")) {
      let _contentPopup = document.getElementById("popup-content");
      let dataDuAn = undefined;
      if (this.props.isEnableLayer.includes("QHPK_Polygon") 
      // && this.props.listPhanKhu
      ) {
        if (data && data.OBJECTID) {
          let res = await AxiosGetSecretApi(
            `/api/qh-phan-khu/getById-mb?ID=${data.OBJECTID}`
          );
          if (res && res.length !== 0) {
            dataDuAn = res[0];
            if (res && res.length !== 0) {
              dataDuAn = res[0];
              this.drawPolygon(res[0], null, 'true');
            }
          }
        }
      }
      _contentPopup.innerHTML =
        '<div class="header-title-popup">Thông tin chi tiết mặt bằng quy hoạch</div>' +
        "</hr>" +
        `<div style="display: flex;">
              <div class="text-title-popup">Tên phân khu:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.TenPhanKhu ? dataDuAn.TenPhanKhu : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Tên loại đất:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.TenloaiPolygon
                  ? dataDuAn.TenloaiPolygon
                  : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Diện tích (ha):</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.DienTichFormat ? StaticClass.formatPrice(dataDuAn.DienTichFormat) : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Mô tả:</div>
              <div class="text-content-popup">${
                dataDuAn && dataDuAn.MoTa ? dataDuAn.MoTa : "-"
              }</div>
          </div> `;
      this._overlayPopup.setPosition(this._coordinateOverlay);
      return;
    }
  }

  // Search QHCT
  onSearchQHCT = async (data) => {
    this.setState({ isLoading: true });
    let tenDuAn = encodeURIComponent(data.selectedDuAn);
    let url = "/api/duanqh/tim-theo-ten?";
    url += `name=${tenDuAn}&`;
    url += `IDPhuong=${data.selectedPhuong}`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      // this.drawLine(res[0].Shape);
      this.drawPolygon(res[0]);
      // this.getDataQuyHoach(res[0].Madoan);
      // this.getDataQuyHoachPhanKhu(res[0].Madoan);
      this.setState({
        isShowSearchQHCT: true,
        isShowSearchQHPK: false,
        isShowSearchKienTruc: false,
        isShowSearchQHC: false,
        isShowSearchNamQHC: false,
        isShowSearchPopup:false,
        dataSearchResultQHCT: res[0],
      });
    } else {
      message.error("Không có thông tin (dữ liệu đang cập nhật)");
    }
    this.setState({ isLoading: false });
  }; 

 
  
  onSearchVKT = async (data) => {
    this.setState({ isLoading: true });
    let tenDuAn = encodeURIComponent(data.selectedDuAn);
    let url = "/api/vung-kien-truc/tim-theo-ten?";
    url += `name=${tenDuAn}&`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      // this.drawLine(res[0].Shape);
      this.drawPolygon(res[0], 'hideMarker');
      // this.getDataQuyHoach(res[0].Madoan);
      // this.getDataQuyHoachPhanKhu(res[0].Madoan);
      this.setState({
        isShowSearchQHCT: false,
        isShowSearchQHPK: false,
        isShowSearchKienTruc: true,
        isShowSearchQHC: false,
        isShowSearchNamQHC: false,
        isShowSearchPopup:false,
        dataSearchResultKienTruc: res[0],
      });
    } else {
      message.error("Không có thông tin (dữ liệu đang cập nhật)");
    }
    this.setState({ isLoading: false });
  };  
  
  onSearchQHPK = async (data) => {
    this.setState({ isLoading: true });
    let tenDuAn = encodeURIComponent(data.selectedPhanKhu);
    let url = "/api/qh-phan-khu/getByNamePK?";
    url += `TenPhanKhu=${tenDuAn}&`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      // this.drawLine(res[0].Shape);
      this.drawPolygon(res[0]);
      // this.getDataQuyHoach(res[0].Madoan);
      // this.getDataQuyHoachPhanKhu(res[0].Madoan);
      this.setState({
        isShowSearchQHCT: false,
        isShowSearchQHPK: true,
        isShowSearchKienTruc: false,
        isShowSearchQHC: false,
        isShowSearchNamQHC: false,
        isShowSearchPopup:false,
        dataSearchResultQHPK: {...res[0], MaPhanKhu:res[0].OBJECTID }, // change to match case when this.props.isEnableLayer.includes("QHPK_Polygon")
      });
    } else {
      message.error("Không có thông tin (dữ liệu đang cập nhật)");
    }
    this.setState({ isLoading: false });
  };  

  onSearchLoaiDat = async (OBJECTID) => {
    this.setState({
      isShowSearchQHCT: false,
      isShowSearchQHPK: false,
      isShowSearchKienTruc: false,
      isShowSearchQHC: true,
      isShowSearchNamQHC: false,
      isShowSearchPopup:false,
      dataSearchResultQHC: {OBJECTID },
    });
  };   
  
  onSearchQHC = async (data) => {
    this.setState({ isLoading: true });
    let NamQH = encodeURIComponent(data.selectedNamQH);
    let url = "/api/qh-chung/getByNamQH?";
    url += `NamQH=${NamQH}&`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      // this.drawLine(res[0].Shape);
      // this.drawPolygon(res[0]);
      // // this.getDataQuyHoach(res[0].Madoan);
      // // this.getDataQuyHoachPhanKhu(res[0].Madoan);
      this.setState({
        isShowSearchQHCT: false,
        isShowSearchQHPK: false,
        isShowSearchKienTruc: false,
        isShowSearchQHC: false,
        isShowSearchNamQHC: true,
        isShowSearchPopup:false,
        dataSearchResultNamQHC: res[0], 
      });
    } else {
      message.error("Không có thông tin (dữ liệu đang cập nhật)");
    }
    this.setState({ isLoading: false });
  };

  // download map

  onDownloadImgOverlay = () => {
    if (this.state.BDGiay_10000) {
      // window.open(this.srcImgFull10000, "_blank");
      if(!this.srcImgFull10000){
        message.error("Không có thông tin (dữ liệu đang cập nhật)");
        return
      }
      var a = document.createElement("a");
      a.href = this.srcImgFull10000;
      a.setAttribute("download", 'bandogiay');
      a.click();
    } else {
      // window.open(this._imgOvelayerLink, "_blank");
      // window.open(this.srcImgFull, "_blank");
      if(!this.state.srcImgFull){
        message.error("Không có thông tin (dữ liệu đang cập nhật)");
        return
      }
      var a = document.createElement("a");
      a.href = this.state.srcImgFull;
      a.setAttribute("download", 'bandogiay');
      a.click();
      
    }
  };

  onFullMap = () => {
    if(this.srcImgFull10000){
      this.setState({
        isShowFullImg: true,
      });
      return
    }
    if(this.state.srcImgFull){
      this.setState({
        isShowFullImg: true,
      });
      return
    }
    message.error("Không có thông tin (dữ liệu đang cập nhật)");
  };

  onResetMap = () => {
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorSource) {
      this._vectorSource.clear();
    }

    if (this._vectorLayer_MB) {
      this._vectorLayer_MB.setSource(undefined);
      this._overlayPopup.setPosition(undefined);
    }

    if (this.vectorSource1) {
      this.vectorSource1.clear();
    }
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }
    this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);
  };

  // --------------------fullscreen--------------------
  handleFullScreen() {
    document.fullscreen
      ? document.exitFullscreen()
      : document.getElementById("mainlayout").requestFullscreen();
  }
  // --------------------=====--------------------

  // --------------------search-function--------------------
  getAllDataDuAn(res) {
    // this.drawLine(res[0].SHAPE);
    this.drawPolygon(res[0]);
    this.getDataQuyHoach(res[0].MaDuAnQH);
    this.getDataQuyHoachPhanKhu(res[0].MaQHPhanKhu);
    this.getDataKienTruc(res[0].MaKVKT);
    this.setState({
      dataThuaDat: { ...res[0], TenTinh: "Đà Nẵng" },
      isShowResultPopup: true,
      isShowSearchPopup: false,
      isShowSearchKienTruc: false,
      isShowSearchQHC: false,
      isShowSearchNamQHC: false,
      isShowSearchQHPK: false,
      isShowSearchQHCT: false,
    });
  }

  async getDataQuyHoach(code) {
    let dataQuyHoach = undefined;
    if (code) {
      let res = await AxiosGetSecretApi(`/api/duanqh/tim-theo-ma?code=${code}`);
      if (res && Array.isArray(res) && res.length !== 0) {
        dataQuyHoach = res[0];
      }
    }
    this.setState({
      dataQuyHoach: dataQuyHoach,
    });
  }

  async getDataQuyHoachPhanKhu(code) {
    let dataQuyHoach = undefined;
    if (code) {
      let res = await AxiosGetSecretApi(
        `/api/duanqh/tim-theo-ma-phan-khu?code=${code}`
      );
      if (res && Array.isArray(res) && res.length !== 0) {
        dataQuyHoach = res[0];
      }
    }

    this.setState({
      dataQuyHoachPhanKhu: dataQuyHoach,
    });
  }

  async getDataKienTruc(code) {
    let res = await AxiosGetSecretApi(
      `/api/kien-truc/tim-theo-ma?code=${code}`
    );
    let dataKienTruc = undefined;
    if (res && Array.isArray(res) && res.length !== 0) {
      dataKienTruc = res[0];
    }
    this.setState({
      dataKienTruc: dataKienTruc,
    });
  }

  // tim theo to thua
  searchBySoTo = async (data) => {
    this.setState({ isLoading: true });
    let url = "/api/ranh-gioi-qh/tim-theo-to-thua?";
    url += `soThua=${data.SoThua}&`;
    url += `soTo=${data.SoTo}&`;
    url += `phuongXa= ${data.selectedPhuong}&`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.getAllDataDuAn(res);
    } else {
      message.error("Không có thông tin (dữ liệu không hợp lệ)");
    }
    this.setState({ isLoading: false });
  };

  // tim theo dia chi
  searchByDiaChi = async (data) => {
    this.setState({ isLoading: true });
    let url = "/api/ranh-gioi-qh/tim-theo-dia-chi?";

    url += `&Phuong=${data.selectedPhuong}`;
    url += `Duong=${data.selectedDuong}&`;
    url += `&soNha=${data.SoNha}`;

    if (data.Kiet) {
      url += `&Kiet=${data.Kiet}`;
    }

    if (data.Hem) {
      url += `&Hem=${data.Hem}`;
    }

    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.getAllDataDuAn(res);
    } else {
      message.error("Không có thông tin (dữ liệu không hợp lệ)");
    }
    this.setState({ isLoading: false });
  };

  // tim theo quy hoach
  searchByDuAn = async (data) => {
    this.setState({ isLoading: true });
    let tenDuAn = encodeURIComponent(data.selectedDuAn);
    let url = "/api/duanqh/tim-theo-ten?";
    url += `name=${tenDuAn}&`;
    url += `IDPhuong=${data.selectedPhuong}`;
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length !== 0) {
      // this.drawLine(res[0].Shape);
      this.drawPolygon(res[0]);
      this.getDataQuyHoach(res[0].Madoan);
      this.getDataQuyHoachPhanKhu(res[0].Madoan);
      this.setState({
        dataKienTruc: undefined,
        dataQuyHoach: res[0],
        dataQuyHoachPhanKhu: undefined,
        dataThuaDat: undefined,

        isShowResultPopup: true,
        isShowInfoPopup: false,
        isShowSearchPopup: false,
      });
    } else {
      message.error("Không có thông tin (dữ liệu đang cập nhật)");
    }
    this.setState({ isLoading: false });
  };

  // tim theo toa do
  searchByToaDo = async (data) => {
    this.setState({ isLoading: true });
    let res = await AxiosGetSecretApi(
      `/api/ranh-gioi-qh/tim-theo-toa-do?x=${data.toaDoX}&y=${data.toaDoY}`
    );
    if (res && Array.isArray(res) && res.length !== 0) {
      this.getAllDataDuAn(res);
    } else {
      message.error("Không có thông tin (dữ liệu không hợp lệ)");
    }
    this.setState({ isLoading: false });
  };
  // --------------------=====--------------------

  // --------------------popup-control-function--------------------
  HandleChangeBackground(value, type) {
    switch (type) {
      case "VeTinh":
        this.arrLayer[1].setVisible(value);
        this.arrLayer[0].setVisible(false);
        this.setState({
          checkedVeTinh: value,
          checkedBanDo: false,
        });
        break;

      case "BanDo":
        this.arrLayer[0].setVisible(value);
        this.arrLayer[1].setVisible(false);
        this.setState({
          checkedVeTinh: false,
          checkedBanDo: value,
        });
        break;

      default:
        break;
    }
  }

  showSearchPopup = () => {
    this.setState({
      isShowSearchPopup: true,
      isShowResultPopup: false,
      isShowInfoPopup: false,
    });
  };

  closeSearchPopup() {
    this.setState({
      isShowSearchPopup: false,
    });
  }

  showNotePopup() {
    this.setState({
      isShowNotePopup: true,
    });
  }

  closeNotePopup() {
    this.setState({
      isShowNotePopup: false,
    });
  }

  closeResultPopup = () => {
    this.setState({
      isShowResultPopup: false,
    });
  };

  handleCloseThongTinDuAn = () => {
    this.setState({
      isShowInfoPopup: false,
      thongTinDuAn: undefined,
    });
  };

  // --------------------====================--------------------

  drawRing = (data) => {
    //draw line
    // this.map.getView().setZoom(14);
    // this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    // this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      // this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayer) {
        this._vectorLayer.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayer = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
              width: 6,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer);
      }
    }
  };

  drawPolygon = (data, hideMarker, isVectorLayer_MB) => {
    let geom = undefined;
    if (data && data._geom) {
      geom = JSON.parse(data._geom);
    }

    let feature;
    if (geom.type === "MultiPolygon") {
      // MultiPolygon
      let convert = geom.coordinates.map((arrCD) => {
        return [
          arrCD[0].map((e) => {
            let arrLocation;
            arrLocation = proj4("EPSG:6959").inverse(e);
            arrLocation = ol.proj.transform(
              arrLocation,
              "EPSG:4326",
              "EPSG:3857"
            );
            return arrLocation;
          }),
        ];
      });
      feature = new ol.Feature({
        geometry: new ol.geom.MultiPolygon(convert),
      });
    } else {
      let convert = geom.coordinates[0].map((e) => {
        let arrLocation;
        arrLocation = proj4("EPSG:6959").inverse(e);
        arrLocation = ol.proj.transform(arrLocation, "EPSG:4326", "EPSG:3857");
        return arrLocation;
      });
      feature = new ol.Feature({
        geometry: new ol.geom.Polygon([convert]),
      });
    }
    // feature.getGeometry().transform("EPSG:4326", "EPSG:3857");

    let vectorSource = new ol.source.Vector({
      features: [feature],
    });

    let aa = feature.getGeometry().getExtent();
    let oo = ol.extent.getCenter(aa);
    if(!hideMarker)this._iconGeometry.setCoordinates(oo);
    this.map.getView().setCenter(oo);

    this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

    if (this.map.getView().getZoom() > 21) {
      this.map.getView().setZoom(21);
    }

    if(isVectorLayer_MB){
      if (this._vectorLayer_MB) {
        this._vectorLayer_MB.setSource(
          new ol.source.Vector({
            features: [feature],
          })
        );
      } else {
        this._vectorLayer_MB = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            stroke: new ol.style.Stroke({ color: "#OOFFFF", width: 6 }),
            // fill: new ol.style.Fill({ color: "#4286f430" }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer_MB);
      }
      return;
    }

    if (this._vectorLayer) {
      this._vectorLayer.setSource(
        new ol.source.Vector({
          features: [feature],
        })
      );
    } else {
      this._vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        style: new ol.style.Style({
          stroke: new ol.style.Stroke({ color: "#00FFFF", width: 6 }),
          // fill: new ol.style.Fill({ color: "#4286f430" }),
        }),
      });
      this.map.getLayers().push(this._vectorLayer);
    }
  };

  showMakerPointAround = async (dataThuaDat) => {
    this.hideMakerPointAround();
    let self = this;
    if (!dataThuaDat || !dataThuaDat.SHAPE) return;

    let sourceLayer = new ol.source.Vector({});

    await dataThuaDat.SHAPE.points.map((o, index, arr) => {
      let newToado = proj4.transform(
        new proj4.Proj("EPSG:6959"),
        new proj4.Proj("EPSG:3857"),
        { x: o.x, y: o.y }
      );

      let iconLocation = new ol.geom.Point([newToado.x, newToado.y]);
      let iconFeature = new ol.Feature({
        geometry: iconLocation,
        name: "" + (index + 1),
      });

      let iconStyle = new ol.style.Style({
        fill: new ol.style.Fill({
          color: "#1e0aff",
        }),
        stroke: new ol.style.Stroke({
          color: "#ffe007",
          width: 1,
        }),
        image: new ol.style.Circle({
          radius: 4,
          fill: new ol.style.Fill({
            color: "#ff1f1a",
          }),
        }),
        text: new ol.style.Text({
          text: arr.length === index + 1 ? "1" : "" + (index + 1),
          offsetY: -20,
          fill: new ol.style.Fill({
            color: "#001b57",
          }),
          stroke: new ol.style.Stroke({
            color: "#ffffff",
            width: 1,
          }),
          font: 16 + "px sans-serif",
        }),
      });

      iconFeature.setStyle(iconStyle);

      sourceLayer.addFeature(iconFeature);
    });

    this._markerAround = new ol.layer.Vector({ source: sourceLayer });

    self.map.addLayer(self._markerAround);
  };

  hideMakerPointAround = () => {
    if (this._markerAround) {
      this.map.removeLayer(this._markerAround);
      this._markerAround = null;
    }
  };

  render() {
    // // console.log(this.props.isEnableLayer.some(r => ['QHPK_RanhGioi','QHPK_Line','QHPK_Polygon'].includes(r)));
    // console.log(this.srcImgFull)
    // console.log(this.props.isEnableLayer?.includes('KienTruc') ,'1');
    // console.log(!this.props.isEnableLayer.some(r => ['QHCT_Polygon','QHPK_Polygon','QHC_Polygon'].includes(r)));
    return (
      <MainLayout {...this.props} title={"Thông tin quy hoạch"}>
        <Spin spinning={this.state.isLoading}>
          <div className="map-bound" id="map-bound">
            <div id="map" className="map map-div home-page">
              {/* -----Vi-tri-+-full----- */}
              <div className="map-button-control">
                <button
                  className="btn-geo-on-map map-control-button"
                  onClick={() => getMyLocation(this)}
                >
                  <i className="fa fa-location-arrow" />
                </button>

                <button 
                  className="btn-fullscreen-on-map map-control-button"
                  onClick={() => {
                    this.handleFullScreen();
                  }}
                >
                  <i className="fa fa-arrows-alt" aria-hidden="true" />
                </button>
              </div>

              {/* -----nen + thao tac + chu giai----- */}
              <div className="map-button-type-map">
                {/* doi nen ban do  */}
                <Dropdown
                  overlay={
                    <Menu className="menu-layer">
                      <Menu.Item key="VeTinh">
                        <div className="fl-bw">
                          <div className="text">Vệ tinh</div>
                          <Switch
                            checked={this.state.checkedVeTinh}
                            onChange={(value) =>
                              this.HandleChangeBackground(value, "VeTinh")
                            }
                          ></Switch>
                        </div>
                      </Menu.Item>
                      <Menu.Divider />

                      <Menu.Item key="BanDo">
                        <div className="fl-bw">
                          <div className="text">Đường phố</div>
                          <Switch
                            checked={this.state.checkedBanDo}
                            onChange={(value) =>
                              this.HandleChangeBackground(value, "BanDo")
                            }
                          ></Switch>
                        </div>
                      </Menu.Item>
                        
                     { this.props.isEnableLayer.some(r => ['QHCT_Polygon','QHPK_Polygon','QHC_Polygon'].includes(r)) && <>
                     <Menu.Divider />
                        <Menu.Item>
                          <div className="fl-bw">
                            <div className="text">Bản đồ giấy</div>
                            <Switch
                              checked={this.state.checkedBanDoGiay}
                              onChange={(value) => {

                                if (this._vectorLayer_MB) {
                                  this._vectorLayer_MB.setSource(undefined);
                                  this._overlayPopup.setPosition(undefined);
                                }
                                
                                if(this.props.isEnableLayer?.includes('QHC_Polygon')) {
                                  changeBanDoGiay10000(value, this)
                                }
                                if(this.props.isEnableLayer?.includes('QHPK_Polygon')) {
                                  changeBanDoGiay5000(value, this)
                                }
                                if(this.props.isEnableLayer?.includes('QHCT_Polygon')) {
                                  changeBanDoGiay500(value, this)
                                }
                              }}
                            ></Switch>
                          </div>
                        </Menu.Item>
                      </>}

                        {/* {!(this.props.isEnableLayer?.includes('KienTruc') || !this.props.isEnableLayer.some(r => ['QHCT_Polygon','QHPK_Polygon','QHC_Polygon'].includes(r))) &&  <><Menu.Divider /> <Menu.SubMenu
                          title={
                            <div className="fl-bw">
                              <div className="text">Bản đồ giấy</div>
                              <i className="fas fa-caret-down"></i>
                            </div>
                          }
                          popupClassName="map-type-sub-menu"
                        >
                          <Menu.Item
                            disabled={!this.props.isEnableLayer.includes('QHCT_Polygon')}
                          >
                            <div className="fl-bw" style={{ width: "250px" }}>
                              <div className="text">
                                Quy hoạch chi tiết 1/500
                              </div>
                              <Switch
                                checked={this.state.BDGiay_500}
                                onChange={(value) => {
                                  changeBanDoGiay500(value, this);
                                }}
                                disabled={!this.props.isEnableLayer.includes('QHCT_Polygon')}
                              ></Switch>
                            </div>
                          </Menu.Item>
                          <Menu.Divider />

                          <Menu.Item key="5000"
                          disabled={!this.props.isEnableLayer.includes('QHPK_Polygon')}>
                            <div className="fl-bw">
                              <div className="text">
                                Quy hoạch phân khu 1/5000
                              </div>
                              <Switch
                                checked={this.state.BDGiay_5000}
                                onChange={(value) => {
                                  changeBanDoGiay5000(value, this);
                                }}
                                disabled={!this.props.isEnableLayer.includes('QHPK_Polygon')}
                              ></Switch>
                            </div>
                          </Menu.Item>
                          <Menu.Divider />

                          <Menu.Item key="10000"
                          disabled={!this.props.isEnableLayer.includes("QHC_Polygon")}>
                            <div className="fl-bw">
                              <div className="text">
                                Quy hoạch chung 1/10000
                              </div>
                              <Switch
                                checked={this.state.BDGiay_10000}
                                onChange={(value) => {
                                  changeBanDoGiay10000(value, this);
                                }}
                                disabled={!this.props.isEnableLayer.includes("QHC_Polygon")}
                              ></Switch>
                            </div>
                          </Menu.Item>
                        </Menu.SubMenu></>} */}
                      {/* ) : (
                        <Menu.Item key="500">
                          <div className="fl-bw">
                            <div className="text">Bản đồ giấy</div>
                            <Switch
                              checked={this.state.BDGiay_500}
                              onChange={(value) => {
                                changeBanDoGiay500(value, this);
                              }}
                            ></Switch>
                          </div>
                        </Menu.Item>
                      )} */}
                    </Menu>
                  }
                  trigger={["click"]}
                  onClick={() => this.closeNotePopup()}
                  // visible = {undefined}
                >
                  <Tooltip title="Chuyển đổi nền" placement="bottom">
                    <button className="map-control-button-type-map button-left">
                      <i className="fas fa-map"></i>
                    </button>
                  </Tooltip>
                </Dropdown>

                {/* chu giai */}
                <Tooltip title="Chú giải" placement="bottom">
                  <button className="map-control-button-type-map">
                    <i
                      className="fas fa-list-ul"
                      onClick={() => {
                        if (this.state.isShowNotePopup) {
                          this.closeNotePopup();
                        } else {
                          this.showNotePopup();
                        }
                      }}
                    ></i>
                  </button>
                </Tooltip>

                {/* thao tac */}
                {this.isLogged() &&  <Dropdown
                  overlay={
                    <Menu className="menu-layer">
                      <Menu.Item
                        key="0"
                        onClick={() => {
                          removeVecterDraw(this);
                          this.onChangeTypeTool("point");
                          if (this.buttonClick === undefined) {
                            this.buttonClick = "ChamDiem";
                          } else {
                            if (this.buttonClick !== "ChamDiem") {
                              this.buttonClick = "ChamDiem";
                              this.sketch = null;
                            }
                          }
                        }}
                      >
                        <Tooltip
                          placement="left"
                          title={() => (
                            <div>
                              <div style={{ textAlign: "justify" }}>
                                Click chuột trái vào vị trí muốn chấm điểm trên
                                bản đồ làm tiền đề cho chức năng Đo khoảng cách
                                và Đo diện tích
                              </div>
                            </div>
                          )}
                        >
                          <div className="text ml-10">Chấm điểm</div>
                        </Tooltip>
                      </Menu.Item>
                      <Menu.Divider />

                      <Menu.Item
                        key="1"
                        onClick={() => {
                          this.onChangeTypeTool("length");
                          if (this.buttonClick === undefined) {
                            this.buttonClick = "KhoangCach";
                          } else {
                            if (this.buttonClick !== "KhoangCach") {
                              this.buttonClick = "KhoangCach";
                              this.sketch = null;
                            }
                          }
                        }}
                      >
                        <Tooltip
                          placement="left"
                          title={() => (
                            <div>
                              <div style={{ textAlign: "justify" }}>
                                Click chuột trái (1 lần) vào các vị trí đã chấm
                                điểm để tiến hành đo khoảng cách
                              </div>
                              <div style={{ textAlign: "justify" }}>
                                Click chuột trái (2 lần) vào điểm cuối của vị
                                trí đo khoảng cách để dừng thao tác
                              </div>
                            </div>
                          )}
                        >
                          <div className="text ml-10">Đo khoảng cách</div>
                        </Tooltip>
                      </Menu.Item>
                      <Menu.Divider />

                      <Menu.Item
                        key="2"
                        onClick={() => {
                          this.onChangeTypeTool("area");
                          if (this.buttonClick === undefined) {
                            this.buttonClick = "DienTich";
                          } else {
                            if (this.buttonClick !== "DienTich") {
                              this.buttonClick = "DienTich";
                              this.sketch = null;
                            }
                          }
                        }}
                      >
                        <Tooltip
                          placement="left"
                          title={() => (
                            <div>
                              <div style={{ textAlign: "justify" }}>
                                Click chuột trái (1 lần) vào vị trí đã chấm điểm
                                để tiến hành đo diện tích
                              </div>
                              <div style={{ textAlign: "justify" }}>
                                Click chuột trái (2 lần) vào điểm cuối của vị
                                trí đo diện tích để dừng thao tác
                              </div>
                            </div>
                          )}
                        >
                          <div className="text ml-10">Đo diện tích</div>
                        </Tooltip>
                      </Menu.Item>
                      <Menu.Divider />

                      <Menu.Item
                        key="4"
                        onClick={() => {
                          removeVecterDraw(this);
                          this.onChangeTypeTool("none");
                          this.Point && this.Point.setActive(false);
                        }}
                      >
                        <div className="text ml-10">Tắt phép đo</div>
                      </Menu.Item>

                      <Menu.Divider />
                      <Menu.Item key="3">
                        <div
                          className="text ml-10"
                          id="export-png"
                          crossOrigin="anonymous"
                          onClick={onDownloadMap}
                        >
                          <i className="fas fa-download mr-10"></i>Tải bản đồ
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  onClick={() => this.closeNotePopup()}
                >
                  <Tooltip title="Thao tác bản đồ" placement="bottomRight">
                    <button className="map-control-button-type-map button-right">
                      <i className="fas fa-tools"></i>
                    </button>
                  </Tooltip>
                </Dropdown>}
              </div>

              {/* -----tim-kiem + nen----- */}
              <div className="map-button-search">
                <Tooltip title="Tìm kiếm" placement="bottomLeft">
                  <button
                    className="map-control-button-search button-left"
                    onClick={() => {
                      this.showSearchPopup();
                    }}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </Tooltip>

                {this.isLogged() && <Tooltip title="Lớp dữ liệu/Lớp nền" placement="bottom">
                  <button
                    className="map-control-button-search button-right"
                    onClick={() => {
                      console.log('this.props.isShowMapLayer button', this.props.isShowMapLayer );
                      this.props.showMapLayer(!this.props.isShowMapLayer);
                      // setTimeout(() => {
                      //   this.map.updateSize();
                      // }, 0);
                    }}
                  >
                    <i className="fas fa-layer-group"></i>
                  </button>
                </Tooltip>}
              </div>

              {/* -----popup----- */}
              {this.state.isShowSearchPopup ? (
                <Search
                  close={() => {
                    this.closeSearchPopup();
                  }}
                  // drawPolygonIcon={(SHAPE, shape) =>
                  //   this.drawLine(SHAPE, shape)
                  // }
                  searchBySoTo={this.searchBySoTo}
                  searchByDuAn={this.searchByDuAn}
                  searchByDiaChi={this.searchByDiaChi}
                  searchByToaDo={this.searchByToaDo}
                  drawPolygonSearch={this.drawPolygonSearch}
                  resetMap={this.onResetMap}
                ></Search>
              ) : null}

              {this.state.isShowResultPopup ? (
                <SearchResult
                  close={this.closeResultPopup}
                  search={this.showSearchPopup}
                  showPoint={this.showMakerPointAround}
                  hidePoint={this.hideMakerPointAround}
                  dataThuaDat={this.state.dataThuaDat}
                  dataKienTruc={this.state.dataKienTruc}
                  dataQuyHoach={this.state.dataQuyHoach}
                  dataQuyHoachPhanKhu={this.state.dataQuyHoachPhanKhu}
                ></SearchResult>
              ) : null}

              {this.state.isShowNotePopup ? (
                <Note
                  close={() => {
                    this.setState({ isShowNotePopup: false });
                  }}
                ></Note>
              ) : null}

              {this.state.isShowSearchKienTruc ? (
                <SearchResultKienTruc
                  data={this.state.dataSearchResultKienTruc}
                  close={() => {
                    this.setState({ isShowSearchKienTruc: false });
                  }}
                  drawRing={this.drawRing}
                  showPoint={this.showMakerPointAround}
                  hidePoint={this.hideMakerPointAround}
                ></SearchResultKienTruc>
              ) : null}

              {this.props.isEnableLayer.includes('KienTruc') && this.state.isShowSearchPopup ? (
                <SearchKienTruc
                  close={() => {
                    this.closeSearchPopup();
                  }}
                  onSearchVKT={this.onSearchVKT}
                  resetMap={this.onResetMap}
                ></SearchKienTruc>
              ) : null}

              {this.state.isShowSearchQHCT ? (
                <SearchResultQHCT
                  data={this.state.dataSearchResultQHCT}
                  close={() => {
                    this.setState({ isShowSearchQHCT: false });
                  }}
                  drawRing={this.drawRing}
                  showPoint={this.showMakerPointAround}
                  hidePoint={this.hideMakerPointAround}
                ></SearchResultQHCT>
              ) : null}

              {this.props.isEnableLayer.some(r => ['QHCT_RanhGioi','QHCT_Line','QHCT_Polygon'].includes(r)) && this.state.isShowSearchPopup ? (
                <SearchQHCT
                  close={() => {
                    this.closeSearchPopup();
                  }}
                  // drawPolygonIcon={(SHAPE, shape) =>
                  //   this.drawLine(SHAPE, shape)
                  // }
                  
                  onSearchQHCT={this.onSearchQHCT}
                  drawPolygonSearch={this.drawPolygonSearch}
                  resetMap={this.onResetMap}
                ></SearchQHCT>
              ) : null}

              {this.state.isShowSearchQHPK ? (
                <SearchResultQHPK
                  data={this.state.dataSearchResultQHPK}
                  close={() => {
                    this.setState({ isShowSearchQHPK: false });
                  }}
                  drawRing={this.drawRing}
                  showPoint={this.showMakerPointAround}
                  hidePoint={this.hideMakerPointAround}
                ></SearchResultQHPK>
              ) : null}

              {this.props.isEnableLayer.some(r => ['QHPK_RanhGioi','QHPK_Line','QHPK_Polygon'].includes(r)) && this.state.isShowSearchPopup ? (
                <SearchQHPK
                  close={() => {
                    this.closeSearchPopup();
                  }}
                  drawPolygonIcon={(SHAPE, shape) =>
                    this.drawLine(SHAPE, shape)
                  }
                  onSearchQHPK={this.onSearchQHPK}
                  resetMap={this.onResetMap}
                ></SearchQHPK>
              ) : null}

              {this.state.isShowSearchQHC ? (
                <SearchResultQHC
                  data={this.state.dataSearchResultQHC}
                  close={() => {
                    this.setState({ isShowSearchQHC: false });
                  }}
                  drawRing={this.drawRing}
                ></SearchResultQHC>
              ) : null}              
              
              {this.state.isShowSearchNamQHC ? (
                <SearchResultNamQHC
                  data={this.state.dataSearchResultNamQHC}
                  close={() => {
                    this.setState({ isShowSearchNamQHC: false });
                  }}
                ></SearchResultNamQHC>
              ) : null}

              {this.props.isEnableLayer.some(r => ['QHC_RanhGioiQuyHoach','QHC_Line','QHC_Polygon', 'QHC_HienTrang','QHC_Test'].includes(r)) && this.state.isShowSearchPopup ? (
                <SearchQHC
                  close={() => {
                    this.closeSearchPopup();
                  }}
                  // drawPolygonIcon={(SHAPE, shape) =>
                  //   this.drawLine(SHAPE, shape)
                  // }
                  isShowSearchPopup={this.state.isShowSearchPopup}
                  onSearchLoaiDat={this.onSearchLoaiDat}
                  onSearchQHC={this.onSearchQHC}
                  resetMap={this.onResetMap}
                ></SearchQHC>
              ) : null}

              {this.state.isShowInfoPopup ? (
                <ThongTinDuAn
                  data={this.state.thongTinDuAn}
                  onDownload={this.onDownloadImgOverlay}
                  onFullMap={this.onFullMap}
                  onClose={this.handleCloseThongTinDuAn}
                  type={
                    this.state.BDGiay_500
                      ? "QHCT"
                      : this.state.BDGiay_5000
                      ? "QHPK"
                      : "QHC"
                  }
                  isShowGroupButton={(this.state.BDGiay_10000 &&  this.srcImgFull10000?.length) || this.state.srcImgFull}
                  drawRing={this.drawRing}
                ></ThongTinDuAn>
              ) : null}

              {this.state.isShowFullImg && (
                <Modal
                  title="Thông tin dự án"
                  width={window.screen.width - 300}
                  closable={false}
                  visible={this.state.isShowFullImg}
                  // onOk={handleOk}
                  onCancel={() => {
                    this.setState({ isShowFullImg: false });
                  }}
                  footer={null}
                  className="modal-thong-tin-du-an"
                >
                  <img
                    //  src={`https://sxd.sgmcvietnam.vn${
                     src={`http://10.17.20.52${
                      this.state.BDGiay_10000
                        ? this.srcImgFull10000
                        : this.state.srcImgFull
                    }`}
                    style={{ width: "100%", height: "auto" }}
                    alt=" "
                  ></img>
                </Modal>
              )}
              
            </div>
          </div>
        </Spin>
        <div id="popup" className="ol-popup">
            <a href="#" id="popup-closer" className="ol-popup-closer"  > </a>
            <div id="popup-content" />
          </div>
      </MainLayout>
    );
  }
}

// export default HomaPage;
const mapStateToProps = (state) => {
  return {
    isShowMapLayer: state.menu.isShowMapLayer,
    isShowMenu: state.menu.isShowMenu,
    isResetLayer: state.menu.isResetLayer,
    isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {
  showMapLayer: showMapLayer,
  disableMapLayer: disableMapLayer,
  changeMapLayer: changeMapLayer,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomaPage);
